<template>
  <el-autocomplete ref="branch" placeholder="Buscar bodega..." v-model="branchSearch.name"
    :fetch-suggestions="querySearchAsync" @select="handleSelect" @clear="clear" :trigger-on-focus="false" clearable
    size="medium" style="width: 100%">
    <template slot="prepend"><i class="el-icon-s-home"></i></template>
    <template slot-scope="{ item }">
      <div class style="line-height: 1; padding: 5px 0 5px">
        <i class="mdi mdi-account"></i>
        {{ item.razon_social }}
        <br />
        <small>
          <i class="mdi mdi-clipboard-account"></i>
          {{ item.direccion }}
        </small>
      </div>
    </template>
    <!-- <template slot="suffix">
      <el-button @click="addBranch" class="mt-5" icon="el-icon-plus" size="mini" plain circle></el-button>
    </template> -->
  </el-autocomplete>
</template>

<script>
import { mapMutations } from "vuex";
import { searchBranch } from "@/api/branch"
export default {
  data() {
    return {
      branchSearch: {
        id: (this.default) ? this.default.id : null,
        name: (this.default) ? this.default.razon_social : null,
        phone: (this.default) ? this.default.celular : null,
        meta: (this.default) ? this.default.meta_data : null,
        direction: (this.default) ? this.default.direccion : null,
      }
    }
  },
  props: ['default'],
  watch: {
    default: function (val) {
      if (val)
        this.branchSearch = {
          id: val.id,
          name: val.razon_social,
          phone: val.celular,
          meta: val.meta_data,
          direction: val.direccion,
        }
    }
  },
  methods: {
    ...mapMutations(['setRightMenu']),
    addBranch() {
      this.setRightMenu({
        componentActive: 'product-form-component',
        drawer: true,
        data: {
          icon: 'package-variant',
          title: 'Agregar producto',
          btnRemove: false,
          field_id: null,
          hidden_btn: true,
          edit: false,
        }
      })
    },
    querySearchAsync(queryString, cb) {
      if (queryString && queryString.length > 3) {
        searchBranch(queryString)
          .then(({ data }) => {
            cb(data.data);
          })
          .catch((error) => {
            this.$message.error('Error al buscar sucursal')
            console.log(error);
          });
      }
    },
    handleSelect(item) {
      this.branchSearch = {
        id: item.id,
        name: item.razon_social,
        phone: item.celular,
        meta: item.meta_data,
        direction: item.direccion,
      }
      this.$emit('select', item)
    },
    clear() {
      this.$emit('clear')
    },
    reset() {
      this.branchSearch = {
        id: null,
        name: null,
        phone: null,
        meta: null,
        direction: null,
      }
    }
  },
}
</script>